import { Navigation, Pagination, Swiper } from 'swiper'

Swiper.use([Navigation, Pagination])

const SP_MEDIA_QUERY = window.matchMedia('(max-width: 768px)')

function initParentsVoicesSwiper(el) {
  if (el.swiper) {
    return el.swiper
  }

  return new Swiper(el, {
    loop: false,
    slidesPerView: 1.2,
    spaceBetween: 24,
    centeredSlides: true,
    speed: 400,
    watchOverflow: true,

    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    },

    pagination: {
      el: el.querySelector('.swiper-pagination'),
      clickable: true,
    },
  })
}

function destroyParentsVoicesSwiper(el) {
  if (!el.swiper) {
    return
  }

  el.swiper.destroy(true, true)
}

function updateParentsVoicesSwiper() {
  const swiperEls = document.querySelectorAll('.js-parentsVoices-swiper')
  const isSp = SP_MEDIA_QUERY.matches

  swiperEls.forEach((el) => {
    if (isSp) {
      initParentsVoicesSwiper(el)
    } else {
      destroyParentsVoicesSwiper(el)
    }
  })
}

updateParentsVoicesSwiper()

SP_MEDIA_QUERY.addEventListener('change', updateParentsVoicesSwiper)
